import { FC } from "react";
import { IconPropsType } from ".";

export const Calendar: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0708 13.25V9.875H16.1958V13.25C16.1958 14.3891 15.2724 15.3125 14.1333 15.3125H5.8833C4.74421 15.3125 3.8208 14.3891 3.8208 13.25V11H4.9458V13.25C4.9458 13.7678 5.36553 14.1875 5.8833 14.1875H14.1333C14.6511 14.1875 15.0708 13.7678 15.0708 13.25Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.3208 3.125C8.3208 2.81434 8.06896 2.5625 7.7583 2.5625C7.44764 2.5625 7.1958 2.81434 7.1958 3.125V4.4375H5.59642C5.09928 4.4375 4.64481 4.71838 4.42248 5.16303L2.92248 8.16303C2.48614 9.03572 3.12073 10.0625 4.09642 10.0625H13.5923C14.1573 10.0625 14.6588 9.701 14.8375 9.16505L15.8375 6.16505C16.1208 5.31516 15.4882 4.4375 14.5923 4.4375H13.1958V3.125C13.1958 2.81434 12.944 2.5625 12.6333 2.5625C12.3226 2.5625 12.0708 2.81434 12.0708 3.125V4.4375H8.3208V3.125ZM5.42872 5.66615C5.46048 5.60262 5.5254 5.5625 5.59642 5.5625H14.5923C14.7203 5.5625 14.8107 5.68788 14.7702 5.80929L13.7702 8.80929C13.7447 8.88586 13.673 8.9375 13.5923 8.9375H4.09642C3.95704 8.9375 3.86638 8.79082 3.92872 8.66615L5.42872 5.66615Z"
        fill={props.color}
      />
      <path
        d="M6.6333 11.75C6.6333 11.5429 6.80119 11.375 7.0083 11.375H7.3833C7.59041 11.375 7.7583 11.5429 7.7583 11.75V12.125C7.7583 12.3321 7.59041 12.5 7.3833 12.5H7.0083C6.80119 12.5 6.6333 12.3321 6.6333 12.125V11.75Z"
        fill={props.color}
      />
      <path
        d="M11.5083 11.75C11.5083 11.5429 11.6762 11.375 11.8833 11.375H12.2583C12.4654 11.375 12.6333 11.5429 12.6333 11.75V12.125C12.6333 12.3321 12.4654 12.5 12.2583 12.5H11.8833C11.6762 12.5 11.5083 12.3321 11.5083 12.125V11.75Z"
        fill={props.color}
      />
      <path
        d="M9.0708 11.75C9.0708 11.5429 9.23869 11.375 9.4458 11.375H9.8208C10.0279 11.375 10.1958 11.5429 10.1958 11.75V12.125C10.1958 12.3321 10.0279 12.5 9.8208 12.5H9.4458C9.23869 12.5 9.0708 12.3321 9.0708 12.125V11.75Z"
        fill={props.color}
      />
    </svg>
  );
};
